var _defs, _path, _polygon, _path2, _rect, _circle, _path3, _rect2, _rect3, _rect4, _path4, _path5, _circle2, _circle3, _path6, _path7, _path8, _path9, _rect5, _path10, _path11, _path12, _path13, _rect6, _path14, _polygon2, _polygon3, _path15, _polygon4, _rect7, _rect8, _circle4, _circle5, _circle6, _circle7, _rect9, _rect10, _circle8, _path16, _path17, _path18, _path19, _path20, _path21, _rect11, _path22, _path23, _rect12, _path24, _rect13, _path25, _path26, _path27, _rect14, _path28, _path29, _path30, _path31;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgScooterDude = (_ref, ref) => {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 966.76 1212.66",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cartoon man riding a scooter with a mobile phone in one hand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-dude1{fill:#ffbe21;}.cls-dude2{fill:#fff;}.cls-dude3{fill:#f2b197;}.cls-dude12,.cls-dude4{fill:#30252a;}.cls-dude5{fill:#d87a55;}.cls-dude6{fill:#fa3b3c;}.cls-dude7{fill:#ffc8ae;}.cls-dude8{fill:#ffb7d5;}.cls-dude9{fill:#4756df;}.cls-dude10{fill:#22c67b;}.cls-dude11{fill:#1da061;}.cls-dude12{stroke:#30252a;stroke-miterlimit:10;stroke-width:10px;}.cls-dude13{fill:#3fc88f;}.cls-dude14{fill:#efefef;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude1",
    d: "M960.05,117.85l-3.4,8-29.34,68.89-7,16.4a10.72,10.72,0,0,1-9.87,6.53H850.82A10.73,10.73,0,0,1,841,202.73l3.41-8,29.33-68.89,7-16.4a10.72,10.72,0,0,1,9.87-6.53h59.64A10.74,10.74,0,0,1,960.05,117.85Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-dude2",
    points: "941.65 125.84 888.69 125.84 859.36 194.73 912.31 194.73 941.65 125.84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude3",
    d: "M956.78,209.91,911.11,227.3c-39,11.83-48,18.79-48,18.79L787.27,429s-18.19,46.79-48.43,51.2c-40.71,5.92-59.38-29.74-59.38-29.74l-68.4-119-28.17-49s-12.77-36.28,14.05-55.7,57,15.07,57,15.07l46.82,64.82,10.47,14.49,82-107s17.49-23.66,26.94-37.77c10.69-16,18.5-18.09,18.5-18.09l24.79-8.26L884,143.06s9.54-3.6,12.95,4.67-7.73,16.2-7.73,16.2l-41.87,23.79-6.38,15a10.73,10.73,0,0,0,9.87,14.93h59.64a10.72,10.72,0,0,0,9.87-6.53l24.55-57.66s16.21-3.94,18.33,6.82c1.61,8.17-9.45,10.16-9.45,10.16s10.4.09,11.71,8.24c1.28,7.89-9.59,11-9.59,11s9.23-1.41,10.77,7.65C968,205,956.78,209.91,956.78,209.91Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude4",
    x: 869.68,
    y: 202.49,
    width: 21.6,
    height: 5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude4",
    cx: 918.25,
    cy: 115.03,
    r: 3.53
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude5",
    d: "M879,155.6a15.71,15.71,0,0,1-5-.76,10.62,10.62,0,0,1-6.55-6l4.57-2a5.79,5.79,0,0,0,3.58,3.3c6,2,16.6-2.61,20.19-4.57l2.4,4.39C897.63,150.2,887.67,155.6,879,155.6Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 934.95,
    y: 170.67,
    width: 19.2,
    height: 5,
    transform: "translate(-10.41 274.2) rotate(-16.43)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 925.09,
    y: 191.58,
    width: 31.41,
    height: 5,
    transform: "translate(-16.74 270.86) rotate(-16.24)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 717.62,
    y: 318.18,
    width: 5,
    height: 30.51,
    transform: "translate(-59.05 483.92) rotate(-35.78)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude6",
    d: "M700.73,306.57l-89.67,24.85-28.17-49s-12.77-36.28,14.05-55.7,57,15.07,57,15.07Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude7",
    d: "M663.34,112.25c-1-2.72-2.64-6.48-4.68-11l0,0s5.61-9.8,3.09-13.84-6-2.67-11.64-4l0,.07c-7.53-15.15-17-33.09-26.29-48.69C608,8,569.75,10.19,534.2,31.81c-36,21.88-21.52,66.7-21.52,66.7l15.78,45.72-20.38,88.7h75.59l-3.82-50c24.72,13.22,58.32,6.67,75.61-12.52S668.24,125.19,663.34,112.25Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude8",
    cx: 920.91,
    cy: 1168.82,
    r: 43.84
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude8",
    cx: 272.96,
    cy: 1168.82,
    r: 43.84
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M694.37,1121.74l.9-7.3c.22-1.74,5.45-42.68,19.44-51.7a11,11,0,0,1,9.6-1.38,8.34,8.34,0,0,1,6.07,6.05c3.46,13.83-27.32,45.53-30.84,49.1Zm26.52-55.92a6.28,6.28,0,0,0-3.47,1.12c-8.17,5.26-13.53,26.55-16,40.28,11.92-13,25.9-31.37,24.09-38.6-.21-.83-.71-1.86-2.71-2.49A6.64,6.64,0,0,0,720.89,1065.82Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M687.93,1118.14l8.47-5.49c.1-.06,10.35-6.69,21.82-12.7,24-12.56,30-10.21,32-9.43a6.52,6.52,0,0,1,4.08,4.63,7.46,7.46,0,0,1-1.28,6.3c-8,11.27-50.24,15.36-55,15.79Zm58.34-23.28c-3.35,0-10.56,1.59-25.73,9.52-4.27,2.24-8.36,4.55-11.8,6.58,16.49-2.31,36.16-6.72,40.19-12.4a2.44,2.44,0,0,0,.51-2.19,1.54,1.54,0,0,0-1.06-1.2A5.89,5.89,0,0,0,746.27,1094.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude7",
    d: "M782.69,1168.82H582.31L571.16,1098v0L557,1008.12H675.69l10.1,48.78,12,57.85s48.35,6.37,64.63,15.86C779.22,1140.44,782.69,1168.82,782.69,1168.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude9",
    d: "M782.69,1168.82H582.31L571.16,1098v0h91.62s-6.93-40.55,23-41.09l12,57.85s48.35,6.37,64.63,15.86C779.22,1140.44,782.69,1168.82,782.69,1168.82Z"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude2",
    x: 579.67,
    y: 1149.52,
    width: 198.68,
    height: 5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M108.87,716.67A7.94,7.94,0,0,1,104,715c-5.08-3.91-7.56-14.61-7.59-32.71,0-12.82,1.28-24.81,1.29-24.93l.8-7.31,3.83,6.28a198.48,198.48,0,0,1,10.35,20c6.62,14.89,8.81,25.87,6.5,32.64a11,11,0,0,1-6.67,7A10,10,0,0,1,108.87,716.67Zm-6.93-50.87c-1.24,17.64-.83,40.67,5.08,45.22.68.52,1.71,1,3.66.26a6,6,0,0,0,3.74-4C117.55,698.11,108.54,678.09,101.94,665.8Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M72,709.49a6.53,6.53,0,0,1-4-1.42,7.44,7.44,0,0,1-2.9-5.73c-.74-13.8,29.85-43.23,33.34-46.54l7.32-6.94-3.23,9.55c0,.12-4,11.67-9.23,23.5-11,24.76-17.2,26.64-19.22,27.26A7.17,7.17,0,0,1,72,709.49ZM93.9,667.4c-11.5,12.05-24.18,27.71-23.81,34.67a2.42,2.42,0,0,0,1,2,1.55,1.55,0,0,0,1.58.29c1.81-.56,7-4,16.11-24.51C90.69,675.48,92.46,671.13,93.9,667.4Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude7",
    d: "M0,667.94,157.11,543.56l52.69,48.59,0,0,66.88,61.68-93.06,73.67-38.19-32-45.3-37.93s-41.85,25-60.51,27.68C20.34,688,0,667.94,0,667.94Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude9",
    d: "M0,667.94,157.11,543.56l52.69,48.59,0,0L138,649s30.61,27.49,7.47,46.5l-45.3-37.93s-41.85,25-60.51,27.68C20.34,688,0,667.94,0,667.94Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude2",
    x: -7.61,
    y: 614.25,
    width: 198.68,
    height: 5,
    transform: "translate(-363.03 190.14) rotate(-38.37)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude10",
    d: "M432.79,458.71,318.9,674.76l-67.55-62.52-88.2,115.28L273,843.36s33.42,38.57,76.51,32.33c44.17-6.41,63.44-47.58,63.44-47.58l76.86-142.22L539.14,1018H707.51L620.45,458.71Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-dude11",
    points: "227.58 643.3 323 731.3 468.5 458.71 432.79 458.71 318.9 674.76 251.35 612.24 227.58 643.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-dude11",
    points: "539.14 1018.04 580.71 1018.04 516.16 635.54 489.77 685.89 539.14 1018.04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M492,687.05l-4.42-2.32,57.49-109.68c.87-2.17,9.77-22.4,38.34-22.4v5c-26,0-33.42,18.54-33.72,19.33l-.13.27Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-dude12",
    points: "923.82 1171.32 272.96 1171.32 272.96 1166.32 918.01 1166.32 807.1 425.44 812.04 424.7 923.82 1171.32"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 568.93,
    y: 99.2,
    width: 5,
    height: 21.81,
    transform: "translate(123.33 481.4) rotate(-50.55)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude4",
    x: 610.84,
    y: 72.11,
    width: 15.61,
    height: 5,
    transform: "translate(81.1 389.79) rotate(-37.26)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude4",
    cx: 628.65,
    cy: 85.85,
    r: 3.31
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude4",
    cx: 272.96,
    cy: 1168.82,
    r: 11.57
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude4",
    cx: 920.91,
    cy: 1168.82,
    r: 11.57
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude12",
    cx: 809.36,
    cy: 425.07,
    r: 11.57
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude6",
    x: 167.58,
    y: 1005.54,
    width: 5,
    height: 130.67,
    transform: "translate(-790.98 568.81) rotate(-53.39)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude13",
    x: 163.38,
    y: 1093.19,
    width: 5,
    height: 63.38,
    transform: "translate(-967.26 1030.82) rotate(-76.87)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-dude4",
    cx: 158.63,
    cy: 1162.71,
    r: 3.53
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude14",
    d: "M85.6,232H349.26S368,183.9,306,201.07c0,0-7.22-44.85-60.12-44.85-58,0-82.71,37.79-82.71,37.79S115,191.57,85.6,232Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude2",
    d: "M193.68,212.8c-4.88-16.06-30.31-16.29-30.56-16.29v-5a58.65,58.65,0,0,1,15.13,2.36c10.72,3.21,17.71,9.25,20.21,17.47Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude6",
    d: "M677.49,447.05l-163,33.83s-67.26,2.45-111.69-20.06l5.43-22.61,18.69-77.68L448.45,271l24.38-43.73,89.31-9.42a92.81,92.81,0,0,1,13.73-.87c8.58.07,19.35,1.34,26.57,6.48,12.78,9.1,19.8,25.87,19.56,26.61,0,.15,2.16,8.17,5.71,20.9,5.39,19.32,13.91,49.47,22.36,79.4,8.28,29.25,16.52,58.29,21.77,76.79Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude8",
    d: "M460.14,400a40.07,40.07,0,0,1-51.91,38.24l18.69-77.68A40,40,0,0,1,460.14,400Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude8",
    d: "M671.84,427.14a39.43,39.43,0,0,1-8,.8,40,40,0,0,1-13.81-77.59C658.35,379.6,666.59,408.64,671.84,427.14Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude7",
    d: "M882.35,440.21,859.24,393a32,32,0,0,0-9.52-11.79l-10.44-7.49,13.59-6.39s11.9-6,7.71-16.31c-3.07-7.55-21.38-3.57-21.38-3.57L793.68,355h0C754.48,359.81,601,382.68,601,382.68l-21.45-41.79-36.44-71S512,213.79,472.83,228s-29.38,64.54-29.38,64.54l26,78.87L492,439.68s12.16,48.22,50.32,60.48,68.58-3.64,68.58-3.64l180.92-79s9.65-4.58,18.23-3.83c10.2.88,14.87,4.05,14.87,4.05l-6.2,32.12s-2.11,9.38,4.81,12.18c7.19,2.9,13.16-4.85,13.16-4.85L842.89,447l4.19,15s3.35,10.65,13.88,8.11c9.39-2.27,7.12-13.81,7.12-13.81s7,7.69,14.27,1.81C889.21,452.57,882.35,440.21,882.35,440.21Z"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 862.11,
    y: 409.52,
    width: 5,
    height: 46.3,
    transform: "translate(-55.17 134.75) rotate(-8.64)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude5",
    d: "M845.14,447.91l-4.3-2.55,12.77-21.57c0-.07,7.08-12.94,5.35-24-1.71-10.9-10.58-17.22-10.67-17.28l-27.06-19.42c-.09-.08-9.19-7.48-19-7.27l-.12-5h.59c11.06,0,20.58,7.54,21.61,8.37l26.82,19.25c.41.29,10.68,7.6,12.72,20.58,2,12.79-5.63,26.69-6,27.27Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude6",
    d: "M579.56,340.16l-54.73,15.17-55.34,15.34-26-78.88s-9.78-50.34,29.39-64.54,70.28,41.91,70.28,41.91l7,13.64Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude2",
    x: 453.96,
    y: 289.7,
    width: 5,
    height: 83.06,
    transform: "translate(-80.82 159.77) rotate(-18.27)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude5",
    d: "M843.37,358.94a17.48,17.48,0,0,1-5.28-.76,14.34,14.34,0,0,1-9-8.46l4.58-2a9.47,9.47,0,0,0,5.93,5.68c8,2.52,19.57-4.47,19.69-4.54l2.61,4.26C861.42,353.42,852.29,358.94,843.37,358.94Z"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude5",
    x: 603.27,
    y: 381.72,
    width: 5,
    height: 24.56,
    transform: "translate(-105.43 265.98) rotate(-22.84)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude5",
    d: "M578.55,185.06c-.45-.28-11-6.77-16.1-11.64l3.47-3.61c4.67,4.5,15.13,10.92,15.24,11Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude5",
    d: "M644.44,122.5a11.25,11.25,0,0,1-2.59-.3,12.67,12.67,0,0,1-7.66-5.91l4.41-2.35-2.2,1.18,2.19-1.19a7.64,7.64,0,0,0,4.46,3.41c2.25.52,4.88-.27,7.82-2.35l2.89,4.08C650.53,121.35,647.41,122.5,644.44,122.5Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude4",
    d: "M560.07,141.16c-10.65-5.41-21.43-18.27-16.32-36.34,9.44-33.32,42.7-15.15,42.7-15.15L591,54.19c1.1.09,2.22.14,3.35.14,18.13,0,32.82-12.16,32.82-27.17S612.43,0,594.3,0C579.58,0,567.17,7.69,563,18.75c0,0-8.06-9.52-21.81-4.87C523.77,19.77,525,38.82,525,38.82L504,57.31s-9.52,6.75-10.23,15.45C493,83,501,95,501,95l27.46,49.19S540.22,159.11,560.07,141.16Z"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-dude4",
    x: 328.97,
    y: 669.33,
    width: 5,
    height: 34.52,
    transform: "translate(-395.76 457.66) rotate(-46.76)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude8",
    d: "M579.56,340.16l-54.73,15.17a40,40,0,0,1,23.28-72.58c.68,0,1.35,0,2,.05Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude8",
    d: "M627.71,271a40,40,0,0,1-51.84-54c8.58.07,19.35,1.34,26.57,6.48,12.78,9.1,19.8,25.87,19.56,26.61C622,250.2,624.16,258.22,627.71,271Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude2",
    d: "M577.33,341.3l-36.44-71c-.16-.29-20.31-36.05-47.56-42l1.07-4.88c12.44,2.72,24.8,11.06,36.74,24.81a127.18,127.18,0,0,1,14.16,19.72L581.78,339Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-dude2",
    d: "M639.88,323.45c-19.37-68.59-20.54-72.83-20.31-74a2.21,2.21,0,0,0,0,.88c-.3-1.36-6.69-16.43-18.54-24.85l2.9-4.08c12,8.55,21.51,26.33,20.48,29.43a2.3,2.3,0,0,0,.09-1.17c.24,1.18,3.93,14.69,20.23,72.42Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgScooterDude);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "scooter-dude.16fb51b.svg";